export default "2cb460eebdac015e.svg"